export enum UserStatus {
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED',
  BLOCKED = 'BLOCKED ',
  VIP = 'VIP',
  ACTIVE = 'ACTIVE',
}
